import { cacheKeys } from "@constants/cache-keys";
import { isScreenshotMode } from "@constants/common";
import { mockedUserLeaderboard } from "@constants/mocked-data";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import useClerkUser from "@hooks/useClerkUser";
import { useQuery } from "@tanstack/react-query";
import { type PeriodType, fetchUserRank } from "../api/queries";
const useUserLeaderboard = (scope: PeriodType) => {
	const {
		currentExamContext: { projectId, organizationId },
	} = useExamContext();
	const { userPublicMetadataId } = useClerkUser();

	const { data: response } = useQuery({
		queryKey: [cacheKeys.userLeaderboard, scope],
		queryFn: () =>
			isScreenshotMode
				? mockedUserLeaderboard
				: fetchUserRank({
						periodType: scope,
						projectId,
						organizationId,
						userId: userPublicMetadataId,
					}),
		enabled: !!projectId && !!organizationId && !!userPublicMetadataId,
	});

	return {
		userLeaderboardResponse: response,
	};
};

export default useUserLeaderboard;
